import { render, staticRenderFns } from "./MultiTransferInternalContent.vue?vue&type=template&id=d040b0e0&lang=pug"
import script from "./MultiTransferInternalContent.vue?vue&type=script&lang=js"
export * from "./MultiTransferInternalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports